import { AuthSurface } from "../types";

/** Acquisition origin, independent of the PATIENT_SIGN_UP event surface. */
const SURFACE_SIGNUP_SOURCES = {
  PATIENT_PORTAL_LOGIN: "patient_portal_login",
  SELF_SCHEDULE: "self_schedule",
  FORMS: "forms",
  CHAT_WIDGET: "chat_widget",
  BILLING_PAY: "billing_pay",
  RECEIPT: "receipt",
  SHOP: "shop",
  CHECK_IN: "check_in",
} as const satisfies Partial<Record<AuthSurface, string>>;

export type SignUpSource =
  | (typeof SURFACE_SIGNUP_SOURCES)[keyof typeof SURFACE_SIGNUP_SOURCES]
  | "prompt"
  | "direct";

/** Inline flows use their host surface, never an unrelated URL source tag. */
export function signUpSourceForSurface(surface: AuthSurface): SignUpSource {
  if (surface in SURFACE_SIGNUP_SOURCES) {
    return SURFACE_SIGNUP_SOURCES[
      surface as keyof typeof SURFACE_SIGNUP_SOURCES
    ];
  }
  return "direct";
}

/** Only stable, non-identifying source tags are accepted from signup links. */
export function signUpSourceForTag(tag: string | null): SignUpSource {
  if (tag === "prompt" || tag === "direct") return tag;
  return (
    Object.values(SURFACE_SIGNUP_SOURCES).find((source) => source === tag) ??
    "direct"
  );
}

/** Explicit attribution takes precedence for signups that stay inline. */
export function resolveSignUpSource(source?: SignUpSource): SignUpSource {
  return (
    source ??
    signUpSourceForTag(
      typeof window === "undefined"
        ? null
        : new URLSearchParams(window.location.search).get("source"),
    )
  );
}
